import React, { Suspense, useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
// routes config
import routes from '../routes';
import { useDispatch, useSelector } from 'react-redux';
import { hasRights, isAiEnabled } from '../../src/utils/rights';
import { fetchCustomersBasicList } from '../actions/customer';
import { toastr } from 'src/utils/toast';
import { AppBreadcrumb, routeSkeletonFor } from '.';
import { ProtectedRoute } from 'src/utils/ProtectedRoute';
import Chatbot from 'src/components/Chatbot';

const AppContent = () => {
	const dispatch = useDispatch();
	const location = useLocation();

	const [loading, setLoading] = useState(true);
	const user = useSelector((state) => state.user?.userData?.user);
	const response = useSelector((state) => state.customer?.response);
	const currentCustomer = useSelector((state) => state.customer?.currentCustomer);

	useEffect(() => {
		if (loading && response) {
			if (response.error) {
				toastr.error('Error', response.message);
			} else {
				setLoading(false);
			}
		}
	}, [loading, response]);

	useEffect(() => {
		if (hasRights(user, ['can_view_clients'])) {
			fetchCustomersBasicList({}, dispatch);
		} else {
			setLoading(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user]);

	// Scroll to top on route change
	useEffect(() => {
		const scrollableElement = document.querySelector('.body');
		if (scrollableElement) {
			scrollableElement.scrollTo(0, 0);
		} else {
			window.scrollTo(0, 0);
		}
	}, [location.pathname]);

	// The breadcrumb stays outside Suspense, so while a page's code loads its
	// skeleton sits exactly where the page will render (no jump when it arrives).
	return (
		<div className="content-wrapper">
			<AppBreadcrumb/>
			<div className="content-area">
				{loading ? (
					routeSkeletonFor(location.pathname)
				) : (
					<Suspense fallback={routeSkeletonFor(location.pathname)}>
						<Routes>
							{routes.map((route, idx) => {
								return route.element &&
									<Route key={idx} path={route.path} exact={route.exact} name={route.name} element={
										<ProtectedRoute accessPermission={route.accessPermission}>
											<route.element />
										</ProtectedRoute>
									} />
							})}
						</Routes>
					</Suspense>
				)}
			</div>
			{!loading && isAiEnabled(user, currentCustomer) && (
				<Suspense fallback={null}>
					<Chatbot />
				</Suspense>
			)}
		</div>
	);
};

export default React.memo(AppContent);
